/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.busyModule')

/**
 * BulbBusyService manages the busy indicator, cursor, and backdrop.
 */
.service('BulbBusyService', ['$document', '$modal', '$q', '$timeout', BulbBusyService]);

function BulbBusyService($document, $modal, $q, $timeout) {
  var that = this;

  var modalOptions = {
    templateUrl: 'ajs/components/busy/busy.html',
    windowClass: 'bulb-busy-modal',
    keyboard: false,
    backdrop: 'static'
  };

  var instance = null;
  var busyCount = 0;

  function onKeydown(event) {
    event.preventDefault();
  }

  function createInstance() {
    if (!instance) {
      instance = $modal.open(modalOptions);

      // Prevent keydown events while the busy modal is displayed:
      $document.on('keydown', onKeydown);
      instance.opened.then(function() {
        $timeout(function() {
          // Add styling to backdrop of modal busy.
          // Don't need to remove it, as the background is recreated every time a modal is opened.
          jQuery('.reveal-modal-bg').addClass('bulb-busy-bg');
        });
      });

      // Restore keydown events once the busy modal is closed
      instance.result.finally(function() {
        $document.off('keydown', onKeydown);
      });

      // To make sure we don't try closing the busy before it has finished opening (which throws an exception),
      // go ahead and wait for the opened promise to resolve just like any other promise:
      that.showBusyDuring(instance.opened);
    }
  }

  this.hideBusy = function() {
    busyCount--;
    if (busyCount <= 0) {
      busyCount = 0;
      if (instance) {
        instance.close();
        instance = null;
      }
    }
  };

  /**
   * Show the busy indicator during the processing of the promise.  When the promise is resolved or rejected, remove
   * the busy indicator.
   * Call can be called multiple times, and the busy indicator will remain until all the promises are resovled.
   * @param promise Promise indicating how long to show the busy indicator.
   * @returns {Promise} The original promise so that the original caller can chain the call.
   */
  this.showBusyDuring = function(promise) {
    busyCount++;
    createInstance();
    promise.finally(that.hideBusy);
    return promise;
  };

  /**
   * Function shows the busy indicator, and returns a function that should be called when the caller is no longer
   * busy.
   * @returns {Function} Function to be called to remove the busy indicator.
   */
  this.showBusy = function() {
    var deferred = $q.defer();
    this.showBusyDuring(deferred.promise);
    return deferred.resolve;
  };
}

